import { render, staticRenderFns } from "./AnySwitch.vue?vue&type=template&id=0b252f66"
import script from "./AnySwitch.vue?vue&type=script&lang=js"
export * from "./AnySwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports